import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import SelectListField from '../../../components/Fields/SelectListField';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowTaskQueryModel from '../../../models/WorkflowTaskQueryModel';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';
import FormatUtils from '../../../utils/FormatUtils';

const Project_tab_Workflows: React.FC<ProjectProps> = ({ projectId, refreshDataCounter }) => {
    const [projectWorkflows, setProjectWorkflows] = useState<WorkflowTaskQueryModel[]>()
    const [projectItemWorkflows, setProjectItemWorkflows] = useState<WorkflowTaskQueryModel[]>()
    const [itemRevisionId, setItemRevisionId] = useState(0)
    const { handleException } = useNotifications()
    const formatUtils = new FormatUtils()

    const items = useSelectListOptions('api/v1/selectlist/ItemRevisionsForProject?projectId=' + projectId, '-- Select item');

    useEffect(() => {
        getProjectWorkflows();
    }, [projectId, refreshDataCounter]);

    useEffect(() => {
        getProjectItemWorkflows();
    }, [projectId, itemRevisionId, refreshDataCounter]);

    function getProjectWorkflows() {
        DataService.get<WorkflowTaskQueryModel[]>('api/v1/WorkflowTasks/ByProject?projectId=' + projectId)
            .then(response => {
                setProjectWorkflows(response);
            })
            .catch(e => { handleException(e); });
    }

    function getProjectItemWorkflows() {
        DataService.get<WorkflowTaskQueryModel[]>(`api/v1/WorkflowTasks/ByProjectAndItem?projectId=${projectId}&itemRevisionId=${itemRevisionId}`)
            .then(response => {
                setProjectItemWorkflows(response);
            })
            .catch(e => { handleException(e); });
    }

    function getStatusColor(rowData: WorkflowTaskQueryModel, colInfo: IColInfo): string | undefined {
        const now = new Date(Date.now())
        const dueOn = formatUtils.dateFromString(rowData.dueOn);
        const completedOn = rowData.completedOn
            ? formatUtils.dateFromString(rowData.completedOn)
            : undefined;

        if (dueOn === undefined || dueOn >= now || (completedOn && completedOn <= dueOn))
            return 'Green';

        return 'red';
    }

    return (
        <>
            <DataTable
                name='dtProjectWorkflows'
                tableData={projectWorkflows}
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { getCellBackgroundColor: getStatusColor, sort: false, width: 5 },
                    { title: 'Workflow', dataProp: 'workflow', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Task', dataProp: 'task', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Assigned on', dataProp: 'assignedOn', dataType: 'datetime' },
                    { title: 'Assigned to', dataProp: 'assignedToUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Due on', dataProp: 'dueOn', dataType: 'datetime' },
                    { title: 'Completed on', dataProp: 'completedOn', dataType: 'datetime' },
                    { title: 'Completed by', dataProp: 'completedByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Chosen Action', dataProp: 'chosenWorkflowAction', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Next Action', dataProp: 'nextAction', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Comments', dataProp: 'comments', filterInfo: { filterType: 'Textbox' } },
                    { title: 'Workflow status', dataProp: 'workflowStatus', filterInfo: { filterType: 'CheckboxList' } },
                ]}
                navigateTitle='Task'
                navigateUrl='/plm/Workflow/task/'
            />

            <div style={{marginTop:24}}>
                <SelectListField labelProps={{ text: 'Item Revision', labelSize: 2, required: false }} controlProps={{ name: 'itemRevisionId', onChange: (v: number) => setItemRevisionId(v), value: itemRevisionId }} options={items} />
            </div>
            <div style={{ marginTop: 12 }}>
                <DataTable
                    name='dtProjectItemWorkflows'
                    tableData={projectItemWorkflows}
                    colInfos={[
                        { key: true, dataProp: 'id', visible: false },
                        { getCellBackgroundColor: getStatusColor, sort: false, width: 5 },
                        { title: 'Item Nr', dataProp: 'itemRevision.item', dataType: 'item', sort: 'asc' },
                        { title: 'Revision', dataProp: 'itemRevision.revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Sub-Items', dataProp: 'itemRevisionColors', dataType: 'workflowItemRevisions', sort: false },
                        { title: 'Workflow', dataProp: 'workflow', sort: 'desc', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Task', dataProp: 'task', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Category', dataProp: 'taskCategory', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Assigned on', dataProp: 'assignedOn', dataType: 'datetime' },
                        { title: 'Assigned to', dataProp: 'assignedToUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Due on', dataProp: 'dueOn', dataType: 'datetime' },
                        { title: 'Completed on', dataProp: 'completedOn', dataType: 'datetime' },
                        { title: 'Completed by', dataProp: 'completedByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Chosen Action', dataProp: 'chosenWorkflowAction', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Next Action', dataProp: 'nextAction', filterInfo: { filterType: 'CheckboxList' } },
                        { title: 'Comments', dataProp: 'comments', filterInfo: { filterType: 'Textbox' } },
                        { title: 'Workflow status', dataProp: 'workflowStatus', filterInfo: { filterType: 'CheckboxList' } },
                    ]}
                    navigateTitle='Task'
                    navigateUrl='/plm/Workflow/task/'
                />
            </div>

        </>
    );
}
export default Project_tab_Workflows;